import ApiService from '../services/ApiService'

export class TgsModule {

  constructor() {
    this._apiService = new ApiService()
    this._configElement = document.getElementById('application-config')
    this._baseUrl = this._configElement == null ? '/' : this._configElement.getAttribute('data-base-url') || ''
  }

  namespaced = true

  state = {
    loadedYears: [34],
    fiscalYear: null,
    subject: 'Composite',
    teacherTrends: [],
    teacherMeritPays: [],
    teacherCompositeCriterias: [],
  }
  mutations = {
    setLoadedYears: (state, payload) => {
      state.loadedYears = payload
    },
    setFiscalYear: (state, payload) => {
      state.fiscalYear = payload
    },
    setSubject: (state, payload) => {
      state.subject = payload
    },
    setTeacherTrends(state, payload) {
      state.teacherTrends = payload
    },
    setTeacherMeritPays(state, payload) {
      state.teacherMeritPays = payload
    },
  }

  actions = {
    getFiscalYears: ({ commit }) => {
      commit('setLoadedYears', [34])
      // return this._apiService.Get(`${this._baseUrl}api/teacher-vam/fiscalYears`)
      //   .then(data => commit('setLoadedYears', data))
    },
    getTeacherTrends: ({ commit }, payload) => {
      commit('setTeacherTrends', [])
      if (!payload.fiscalYear || !payload.lea || !payload.subject)
        return Promise.resolve()
      
      return this._apiService.Get(`${this._baseUrl}api/teacher-tgs/${payload.fiscalYear}/${payload.lea}/teachers/trend?subject=${payload.subject}`)
        .then(data => commit('setTeacherTrends', data))
    },
    getTeacherMeritPays: ({ commit }, payload) => {
      commit('setTeacherMeritPays', [])
      if (!payload.fiscalYear || !payload.lea)
        return Promise.resolve()
      
      return this._apiService.Get(`${this._baseUrl}api/merit-incentive/${payload.fiscalYear}/${payload.lea}/teachers/meritpay`)
        .then(data => commit('setTeacherMeritPays', data))
    },
  }
}